export default __webpack_public_path__ + "fonts/ProximaNova-SemiboldIt.ttf";